import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const ModalEjemplo = ({
  mostrarModal,
  cerrarModal,
  idTorneo,
  setSeCancelo,
  limpiarEquiposSeleccionados,
  limpiarBackup,
}) => {
  const handleClose = () => {
    setSeCancelo(true);
    limpiarEquiposSeleccionados();
    limpiarBackup();
    cerrarModal();
  };

  return (
    <Modal show={mostrarModal} onHide={cerrarModal}>
      <Modal.Header closeButton>
        <Modal.Title>¿Desea cancelar la fecha?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Button variant="btn btn-danger" onClick={() => handleClose()}>
          Sí, cancelar fecha
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default ModalEjemplo;
